import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirFlowerTemplates() {
  return {
    templates: [],
    loading: false,

    init() {
      this.fetchList();
    },

    async fetchList() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/flower-templates');
        this.templates = data.data || [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat template.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async approve(t) {
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/flower-templates/${t.id}/approve`);
        const idx = this.templates.findIndex((x) => x.id === t.id);
        if (idx >= 0) this.templates[idx] = data.data;
        window.toast?.(data.message || 'Disetujui.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal approve.', 'error');
      }
    },

    async hold(t) {
      const reason = window.prompt('Alasan hold status (opsional):') || '';
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/flower-templates/${t.id}/hold`, { reason });
        const idx = this.templates.findIndex((x) => x.id === t.id);
        if (idx >= 0) this.templates[idx] = data.data;
        window.toast?.(data.message || 'Di-hold.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal hold.', 'error');
      }
    },

    async remove(t) {
      const ok = await window.confirmDialog?.({
        title: 'Hapus template?',
        message: `Hapus ${t.name}?`,
        confirmText: 'Hapus',
        variant: 'danger',
      });
      if (!ok) return;
      try {
        await axios.delete(`/api/v1/kasir/engagement/flower-templates/${t.id}`);
        this.templates = this.templates.filter((x) => x.id !== t.id);
        window.toast?.('Template dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal hapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirFlowerTemplates', createKasirFlowerTemplates);
